export default function recycle(state) {
  // preserve config as this only loads on page reload
  const { config, ui: { theme } } = state;
  return { config, ui: { theme } };
}
